import { deleteAdlRecord } from "../store/slices/adlRecordsSlice";
import { deleteAnxietyAssessment } from "../store/slices/anxietySlice";
import { deleteBdiAssessment } from "../store/slices/bdiAssessmentsSlice";
import { deleteBprsAssessment } from "../store/slices/bprsAssessmentsSlice";
import { deleteComplaintForm } from "../store/slices/complaintFormSlice";
import { deleteConsentForm } from "../store/slices/consentSlice";
import { deleteDepotInjectionChart } from "../store/slices/depotInjectionChartsSlice";
import { deleteDischargeAdvice } from "../store/slices/dischargeAdviceSlice";
import { deleteDischargeSummary } from "../store/slices/dischargeSummarySlice";
import { deleteExerciseSchedule } from "../store/slices/exerciseSchedulesSlice";
import { deleteFamilyMeetingMinute } from "../store/slices/familyMeetingMinutesSlice";
import { deleteIncidentReport } from "../store/slices/incidentReportsSlice";
import { deleteRehabPlan } from "../store/slices/individualisedRehabPlanSlice";
import { deleteInjection } from "../store/slices/injectionsSlice";
import { deleteIntegratedAssessment } from "../store/slices/integratedAssessmentSlice";
import { deleteLamaForm } from "../store/slices/lamaFormsSlice";
import { deleteMedicationSheet } from "../store/slices/medicationSheetsSlice";
import { deleteNursingRecord } from "../store/slices/nursingRecordsSlice";
import { deleteOcdAssessment } from "../store/slices/ocdAssessmentsSlice";
import { deletePersonalBelonging } from "../store/slices/personalBelongingsSlice";
import { deletePhqAssessment } from "../store/slices/phqAssessmentsSlice";
import { deleteProgressNote } from "../store/slices/progressNotesSlice";
import { deletePsychiatricForm } from "../store/slices/psychiatricFormSlice";
import { deleteQolAssessment } from "../store/slices/qolAssessmentsSlice";
import { deleteReferralForm } from "../store/slices/referralFormsSlice";
import { deleteRelocationForm } from "../store/slices/relocationFormsSlice";
import { deleteSafetyPlan } from "../store/slices/safetyPlansSlice";
import { deleteSafetyPlanUrdu } from "../store/slices/safetyPlansUrduSlice";
import { deleteSanaNote } from "../store/slices/sanaNotesSlice";
import { deleteSuicideDetail } from "../store/slices/suicideDetailsSlice";
import { deleteSuicideIntentAssessment } from "../store/slices/suicideIntentSlice";
import { deleteFamilyPlan } from "../store/slices/tentativeFamilyPlanSlice";
import { deleteViolenceRisk } from "../store/slices/violenceRisksSlice";
import { deleteVitalsChart } from "../store/slices/vitalsSlice";
import { deleteYmrsAssessment } from "../store/slices/ymrsAssessmentsSlice";
import { deleteProsAssessment } from "../store/slices/prosAssessmentsSlice";
import { deleteEscortForm } from "../store/slices/escortFormSlice";
import { deleteHomeVisitClinicalRecord } from "../store/slices/homeVisitClinicalRecordSlice";
import { deleteClientMovementForm } from "../store/slices/clientMovementFormSlice";
import { deleteCros3Form } from "../store/slices/cros3FormSlice";
import { deleteProgressNotePrp } from "../store/slices/progressNotePrpSlice";
import { deleteIndividualClientFile } from "../store/slices/individualClientFileSlice";
import { deleteIndividualRehabPlanTwo } from "../store/slices/individualRehabPlanTwoSlice";
import { deleteTransitionForm } from "../store/slices/transitionFormSlice";
import { deleteLeapParticipationConsent } from "../store/slices/leapParticipationConsentSlice";
import { deleteFamilyFeedback } from "../store/slices/familyFeedbackSlice";
import { deleteClientFeedback } from "../store/slices/clientFeedbackSlice";
import { deleteDrpClientFeedback } from "../store/slices/drpClientFeedbackSlice";

export const formDeleteThunks = {
    "Inquiry Form": null, // No delete action for Inquiry Form
    "Progress Notes PRP": deleteProgressNotePrp,
    "Consent Form": deleteConsentForm,
    "Escort Form [injection]": deleteInjection,
    "Escort Form": deleteEscortForm,
    "Individual Rehabilitation Plan": deleteIndividualRehabPlanTwo,
    "Home Visit Clinical Record Form": deleteHomeVisitClinicalRecord,
    "Personal Belonging": deletePersonalBelonging,
    "Tentative Family Plan": deleteFamilyPlan,
    "Pros Form": deleteProsAssessment,
    "ADL Record Sheet": deleteAdlRecord,
    "Family Meeting Minutes": deleteFamilyMeetingMinute,
    "Incident Report": deleteIncidentReport,
    // "IRP (Individual Rehabilitation Plan)": deleteRehabPlan,
    "Progress Notes Record (Phsyician)[Sana]": deleteSanaNote,
    "Nursing Record": deleteNursingRecord,
    "Progress Notes Record (Psychiatric) - RPR": deleteProgressNote,
    "Progress Notes Record (PRPS) - RPR": deleteProgressNote,
    "Depot injection Chart": deleteDepotInjectionChart,
    "Vitals Monitoring Chart": deleteVitalsChart,
    "Discharge Advice": deleteDischargeAdvice,
    "Lama Policy": deleteLamaForm,
    "Referral Form": deleteReferralForm,
    "Relocation Policy": deleteRelocationForm,
    "Safety Plan": deleteSafetyPlan,
    "Suicide Detail": deleteSuicideDetail,
    "Violence Detail": deleteViolenceRisk,
    "Psych Order": deletePsychiatricForm,
    "Client Movement Request Form": deleteClientMovementForm,
    "CROS-3 Form": deleteCros3Form,
    "Exercise Schedule": deleteExerciseSchedule,
    "Prescription Slip/Medication Sheet": deleteMedicationSheet,
    "Anxiety Form": deleteAnxietyAssessment,
    "Individual Client File Form": deleteIndividualClientFile,
    "LEAP Participation Consent Form": deleteLeapParticipationConsent,
    "Family Feedback Form": deleteFamilyFeedback,
    "Client Feedback Form": deleteClientFeedback,
    "Client Feedback & Discharge Interview": deleteDrpClientFeedback,
    "Transition Form": deleteTransitionForm,
    "BDI-II Form": deleteBdiAssessment,
    "BPRS Form": deleteBprsAssessment,
    "Complaint Form": deleteComplaintForm,
    "Beck Suicide Intent Scale": deleteSuicideIntentAssessment,
    "Depression Patient Health Question": deletePhqAssessment,
    "Obsessive Compulsive Disorder Test": deleteOcdAssessment,
    "Qol2": deleteQolAssessment,
    "YMRS Form": deleteYmrsAssessment,
    "Safety Plan (URDU)": deleteSafetyPlanUrdu,
    "Integrated Assessment Form": deleteIntegratedAssessment,
    "Discharge Summary (Psychiatric)": deleteDischargeSummary,
    "Discharge Summary (Physician)": deleteDischargeSummary,
    "Discharge Summary (Nursing)": deleteDischargeSummary,
    "Discharge Summary (PRPS)": deleteDischargeSummary,
    "Discharge Summary": deleteDischargeSummary,
};